class CartItems extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.sections = window.BAO.sectionRenderer.cartSections
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.onAfterCartAdd = this.onAfterCartAdd.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.AFTER_ADD_FROM_FORM,
      this.onAfterCartAdd,
    )
  }

  async onAfterCartAdd () {
    const { sectionRenderer } = window.BAO
    const sections = await sectionRenderer.fetch(
      this.sections.map(s => s.section),
    )

    this.renderSections(sections)
  }
}

if (!window.customElements.get('cart-items')) {
  window.customElements.define('cart-items', CartItems)
}
